import { BANNER_SUMMARY_REPORT, DAILY_SUMMARY_REPORT, DETAIL_SUMMARY_REPORT, WEBSITE_SUMMARY_REPORT, GET_SUMMARY } from './config';
const initialState = {
    detailSummary: [],
    dailySummary: [],
    websiteSummary: [],
    bannerSummary:[],
    getSummary: [],
}
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case DETAIL_SUMMARY_REPORT:
            return {...state, detailSummary: action.payload}
        case DAILY_SUMMARY_REPORT:
            return {...state, dailySummary: action.payload}
        case WEBSITE_SUMMARY_REPORT:
            return {...state, websiteSummary: action.payload}  
        case BANNER_SUMMARY_REPORT:
            return {...state, bannerSummary: action.payload}
        case GET_SUMMARY:
            return {...state, getSummary:action.payload}    
        default:
            return state;
    }
}

export default reducer;